'use strict';

import angular from 'angular';
import template from './modal.pug';

const MemModalReactivateSvc = [
  '$filter',
  'ModalSvc',
  'LoaderSvc',
  'DatetimeSvc',
  'MemberSvc',
  'MemTypeSvc',
  function(
    $filter,
    ModalSvc,
    LoaderSvc,
    DatetimeSvc,
    MemberSvc,
    MemTypeSvc
  ) {
    /**
     * Opens the groupRole Modal
     * @param  {Object} currentGrpRle   - currentPos
     * @return {Object}                 - the updated pos instance
     */
    function open(ctxId, personId, groups) {
      var modalInstance;
      var modalvm = {};

      modalvm.title = 'Reactivate Member';
      modalvm.today = new Date();
      var groupSelect = [];

      // initiate formvm
      var reactivatevm = {start: DatetimeSvc.getDatePropString()};
      reactivatevm = DatetimeSvc.getFormDateRange(reactivatevm); // add dates
      var membership = [];
      for(var g in groups) {
        if(groups[g].membership && groups[g].membership.length > 0) {
          groupSelect.push(groups[g].group);
        }
        for(var m in groups[g].membership) {
          var mem = groups[g].membership[m];
          if(groups[g].group) { mem.group = {id: groups[g].group.id}; }
          membership.push(mem);
        }
      }
      modalvm.groups = groupSelect;

      var initMem = $filter('orderBy')(membership, 'start', true)[0];
      if(initMem.group) { reactivatevm.groupId = initMem.group.id; }
      if(initMem.type) { reactivatevm.typeId = initMem.type.id; }
      // get member types to select from
      MemTypeSvc.getDefinedFor({groupId: ctxId}).$promise
        .then(function(memTypes) {
          modalvm.memberTypes = memTypes;
        });

      // datepicker
      modalvm.dateFormat = 'M/d/yyyy';
      modalvm.openActive = function($event, dateType) {
        $event.preventDefault();
        $event.stopPropagation();
        modalvm.formvm[dateType + 'Open'] = true;
      };

      // submit
      function onSubmit() {
        modalvm.submitted = true; // modal submits outside of form
        if(modalvm.formvm.$valid) {
          LoaderSvc.start();
          // get start from formStart
          DatetimeSvc.setDatesBasedOnForm(reactivatevm);
          reactivatevm.personId = personId;
          // set dates from form values
          DatetimeSvc.setDatesBasedOnForm(reactivatevm);

          MemberSvc.reactivate({groupId: reactivatevm.groupId, id: personId},
            reactivatevm)
            .$promise.then(function() {
              LoaderSvc.stopSuccess('Member Reactivated');
              modalInstance.close();
            });
        }
      }

      function onCancel() {
        modalInstance.dismiss();
      }

      var modalScope = {modalvm: angular.extend(modalvm, {
        dismissable: true,
        reactivatevm,
        onSubmit,
        buttons: [
          {classes: 'btn-primary', text: 'Activate Member', click: onSubmit},
          {classes: 'btn-default', text: 'Cancel', click: onCancel}
        ]
      })};

      var options = {template};

      modalInstance = ModalSvc.open(modalScope, options);
      return modalInstance.result;
    }

    // Public API here
    return {
      open
    };
  }
];
export default MemModalReactivateSvc;
